// extracted by mini-css-extract-plugin
export default {"avatar":"Logo_avatar__zjeCq","imgContainer":"Logo_imgContainer__Fz9u8"};